import Resetpasswordtoken from './components/Resetpassword';

const Resetpassword = () => {
  return <Resetpasswordtoken />;
};

export default Resetpassword;
